import { create } from 'zustand';

interface FeedbackButtonState {
  // 每个消息的反馈按钮是否显示
  alertMap: Record<string, boolean>;
  showAlert: (messageId: string) => void;
}

export const useFeedbackButtonStore = create<FeedbackButtonState>((set) => ({
  alertMap: {},
  showAlert: (messageId: string) => {
    set((state) => ({
      alertMap: {
        ...state.alertMap,
        [messageId]: true,
      },
    }));
    // 2s后隐藏
    setTimeout(() => set((state) => ({ alertMap: { ...state.alertMap, [messageId]: false } })), 2000);
  },
}));
